import PageScroll from './PageScroll';

export default PageScroll;
